module.exports = __webpack_public_path__ + "b98a52f94b3d8696569bc1b554f91fc2.svg";